const firebaseConfig = {
  apiKey: "AIzaSyCLNADM1JsgQU8zhcIY1Iw727RBqG4zRJM",
  authDomain: "route-database.firebaseapp.com",
  databaseURL: "https://route-database.firebaseio.com",
  projectId: "route-database",
  storageBucket: "route-database.appspot.com",
  messagingSenderId: "659818699320",
  appId: "1:659818699320:web:1542e0105b8e78af9d64cd"
};
// Initialize Firebase
export default firebaseConfig;
